import { Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

type NoResultsStateProps = ComponentProps<'div'> & {
  onRetry?: () => void
}

export function NoResultsState({ onRetry, ...props }: NoResultsStateProps) {
  const t = useTranslations('NoResultsState')

  return (
    <div
      {...props}
      className={`flex flex-col items-center justify-center gap-6 rounded-xl bg-grey-background px-6 py-12 ${props.className ?? ''}`}
    >
      <div className="flex w-full flex-col items-stretch text-center text-mydra-black">
        <Typography variant="h6" className="text-center">
          {t('title')}
        </Typography>
        <Typography variant="body1">{t('description')}</Typography>
      </div>
      <Button onClick={onRetry} variant="contained">
        {t('retry')}
      </Button>
    </div>
  )
}
